// StockPopup.jsx
import React, { useState } from 'react';
import './StockPopup.css';


const StockPopup = ({ isOpen, onClose, onSubmit, onParse }) => {
    const [inputData, setInputData] = useState('');
    const [parsedData, setParsedData] = useState([]);
    const [isProcessing, setIsProcessing] = useState(false);
    const [error, setError] = useState('');

    const handleParse = async () => {
        setIsProcessing(true);
        setError('');
        try {
            const data = await onParse(inputData);
            setParsedData(data);
        } catch (e) {
            setError(e.message);
        } finally {
            setIsProcessing(false);
        }
    };

    return (
        <div className={`stockpopup ${isOpen ? 'stockpopup--open' : ''}`}>
            <div className="stockpopup__overlay" onClick={onClose}></div>
            <div className="stockpopup__content">
                <h2 className="stockpopup__title">Add Scanned Boxes</h2>
                <p className="stockpopup__subtitle">Paste scanned data below</p>
                
                {error && <div className="stockpopup__error">{error}</div>}
                
                <textarea
                    className="stockpopup__textarea"
                    value={inputData}
                    onChange={(e) => setInputData(e.target.value)}
                    placeholder="Paste scanned data here..."
                    disabled={isProcessing}
                />
                
                {isProcessing && (
                    <div className="stockpopup__loader">
                        <div className="stockpopup__spinner"></div>
                        Processing data...
                    </div>
                )}
                
                {parsedData.length > 0 ? (
                    <>
                        <div className="stockpopup__parsed">
                            <h3>Recognized entries ({parsedData.length}):</h3>
                            <ul>
                                {parsedData.map((item, i) => (
                                    <li key={i}>
                                        {item.sku} - Box {item.boxNumber} 
                                        (Qty: {item.quantity}, Date: {item.date})
                                    </li>
                                ))}
                            </ul>
                        </div>
                        <button 
                            className="stockpopup__submit"
                            onClick={() => onSubmit(parsedData)}
                        >
                            Submit to Database
                        </button>
                    </>
                ) : (
                    <button
                        className="stockpopup__parse"
                        onClick={handleParse}
                        disabled={!inputData.trim() || isProcessing}
                    >
                        Parse Data
                    </button>
                )}
                
                <button 
                    className="stockpopup__close"
                    onClick={onClose}
                >
                    Close
                </button>
            </div>
        </div>
    );
};

export default StockPopup;